import React, { useState, useEffect } from "react";
import "../../css/testContainer.css";

const TestContainer = ({
  title,
  notification,
  handleNextTest,
  renderedQuestions,
  testDuration,
  gradeTest,
}) => {
  const [localRemainingTime, setLocalRemainingTime] = useState(testDuration);
  const [isTimeUp, setIsTimeUp] = useState(false);

  // ロールが9（アドミン）の場合に .timer と .next-button を表示
  useEffect(() => {
    const userRole = localStorage.getItem("userRole");
    const userName = localStorage.getItem("userName");
    if (userRole === "9" || userName === "デモユーザ") {
      const timerElement = document.querySelector(".timer");
      const nextButtonElement = document.querySelector(".next-button");
      if (timerElement) timerElement.style.display = "block";
      if (nextButtonElement) nextButtonElement.style.display = "block";
    }
  }, []); // 初回のみ実行

  // タイマーのカウントダウン処理
  useEffect(() => {
    if (localRemainingTime > 0 && !isTimeUp) {
      const timer = setInterval(() => {
        setLocalRemainingTime((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(timer);
            setIsTimeUp(true);
            gradeTest();
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [localRemainingTime, isTimeUp, gradeTest]);

  // タイマーを強制的に0に設定
  const resetTimerToZero = () => {
    setLocalRemainingTime(0);
    setIsTimeUp(true);
    gradeTest();
  };

  return (
    <div className="test-container">
      <h1>{title}</h1>
      <div>
        {isTimeUp ? (
          <div className="overlay">
            <div className="notification">
              <h2>{notification}</h2>
              <button className="next-test-button" onClick={handleNextTest}>
                次に進む
              </button>
            </div>
          </div>
        ) : (
          <div className="questions-container">{renderedQuestions}</div>
        )}
      </div>
      <div className="timer">残り時間: {localRemainingTime}秒</div>
      <div className="next-button">
        <button className="reset-timer-button" onClick={resetTimerToZero}>
          次に進む
        </button>
      </div>
    </div>
  );
};

export default TestContainer;
